import { render, staticRenderFns } from "./view-user-create-business-driver-link.vue?vue&type=template&id=08619194&"
import script from "./view-user-create-business-driver-link.vue?vue&type=script&lang=js&"
export * from "./view-user-create-business-driver-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports